(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("subscriptionPayPalExpressCheckoutConfirmation", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/settings/subscription/checkout/payments/subscriptionPayPalExpressCheckoutConfirmationView.html",
            controller: ["subscriptionCheckoutService", "subscriptionResource", "messageService", "$state", SubscriptionPayPalExpressCheckoutConfirmationCtrl],
            controllerAs: "vm"
        };
        function SubscriptionPayPalExpressCheckoutConfirmationCtrl(subscriptionCheckoutService, subscriptionResource, messageService, $state) {
            subscriptionCheckoutService.start();
            subscriptionResource.confirmPayPalExpressCheckoutPayment({
                token: $state.params["token"],
                payerId: $state.params["PayerID"]
            }, function () {
                subscriptionCheckoutService.wizard.isStep2Valid = true;
                subscriptionCheckoutService.model.details.token = $state.params["token"];
                $state.go("main.settings.subscriptionCheckout.step3", {}, { location: "replace" });
            }, function (error) {
                messageService.error(error);
                $state.go("main.settings.subscriptionCheckout.step2", {}, { location: "replace" });
            });
        }
    });
}());
